module.exports = __webpack_public_path__ + "static/media/social-google.1d6273f2.svg";